import React, { useState } from 'react';

const workHistory = [
  {
    id: 'entropic',
    role: 'AI Team Lead',
    company: 'Entropic',
    period: 'Apr 2024 — Present',
    type: 'Full-time',
    tag: 'Current',
    highlights: [
      'Leading AI engineering across 9+ production projects spanning computer vision, NLP, RL, and full-stack AI platforms.',
      'Delivered Gluon (AI outreach platform), Tender Intelligence Pipeline, Campfire Backend, CyclesGym, Kris AI Avatar, and more.',
      'Architecting multi-modal pipelines — GPT-4o, D-ID, Supabase, FastAPI, React — from zero to production.',
      'Managing documentation, client communication, and technical QA across the team.',
    ],
  },
  {
    id: 'loopteck',
    role: 'AI Engineer',
    company: 'Loopteck',
    period: 'Jun 2023 — Apr 2024',
    type: 'Contract',
    highlights: [
      'Built M-BOT: end-to-end malaria-detection platform for Health Services Academy, Islamabad.',
      'Designed full data-cleaning and preprocessing pipelines from an initial sample dataset.',
      'Led AWS production deployment — serving 30,000 patients/day at under $0.08 per patient.',
      'Built a custom AI auto-focus module for blood-smear imaging hardware.',
    ],
  },
  {
    id: 'tapsmart',
    role: 'Software Engineer',
    company: 'Tap-Smart',
    period: 'Dec 2023 — Feb 2024',
    type: 'Contract',
    highlights: [
      'Developed custom QR Code generation module for Tap-Smart\'s smart card product.',
      'Integrated with the core product team through iterative trial-and-feedback cycles.',
      'Implemented preprocessing steps ensuring reliable generation across hardware variants.',
    ],
  },
  {
    id: 'healthhub',
    role: 'ML Engineer',
    company: 'HealthHub',
    period: 'Jun 2022 — Jan 2023',
    type: 'Full-time',
    highlights: [
      'Worked on tumour segmentation across multiple imaging modalities (MRI, CT).',
      'Developed and maintained internal and external-facing APIs for AI inference services.',
      'Contributed to model training pipelines and evaluation frameworks.',
    ],
  },
];

const education = [
  {
    degree: 'Master of Science — Artificial Intelligence',
    institution: 'National University of Science and Technology (NUST)',
    period: 'Oct 2022 — Present',
    detail: 'MS Thesis: CyclesGym — Reinforcement learning for Pakistan-focused crop simulation. 113 canonical evidence matrix rows, 42 ablation experiments.',
  },
  {
    degree: 'Bachelor of Computer Engineering',
    institution: 'National University of Science and Technology (NUST)',
    period: 'Oct 2018 — Jun 2022',
    detail: 'Final year project led to OsteoDoc — published IEEE Xplore 2024, 0.91 AUC, Best Paper award at ICODT2.',
  },
];

const Experience = () => {
  const [activeTab, setActiveTab] = useState('work');

  return (
    <section className="experience section" id="experience">
      <h2 className="section__title-1"><span>Experience.</span></h2>

      {/* Tab switcher */}
      <div className="experience__tabs">
        <button
          className={`experience__tab-btn${activeTab === 'work' ? ' active' : ''}`}
          onClick={() => setActiveTab('work')}
        >
          <i className="ri-briefcase-line"></i> Work
        </button>
        <button
          className={`experience__tab-btn${activeTab === 'education' ? ' active' : ''}`}
          onClick={() => setActiveTab('education')}
        >
          <i className="ri-graduation-cap-line"></i> Education
        </button>
      </div>

      {/* ── Work timeline ─────────────────────────────────────── */}
      {activeTab === 'work' && (
        <div className="experience__timeline container">
          {workHistory.map((job, idx) => (
            <div className="experience__item" key={job.id}>
              {/* Timeline spine */}
              <div className="experience__spine">
                <div className={`experience__dot${idx === 0 ? ' experience__dot--active' : ''}`} />
                {idx < workHistory.length - 1 && <div className="experience__line" />}
              </div>

              {/* Card */}
              <div className={`experience__card${job.tag ? ' experience__card--current' : ''}`}>
                <div className="experience__card-header">
                  <div>
                    <h3 className="experience__role">{job.role}</h3>
                    <p className="experience__company">
                      <i className="ri-building-line"></i> {job.company}
                    </p>
                  </div>
                  <div className="experience__meta">
                    <span className="experience__period">
                      <i className="ri-calendar-line"></i> {job.period}
                    </span>
                    {job.tag && (
                      <span className="experience__tag experience__tag--current">{job.tag}</span>
                    )}
                  </div>
                </div>
                <ul className="experience__highlights">
                  {job.highlights.map((h, i) => (
                    <li key={i} className="experience__highlight">
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── Education ─────────────────────────────────────────── */}
      {activeTab === 'education' && (
        <div className="experience__timeline container">
          {education.map((ed, idx) => (
            <div className="experience__item" key={idx}>
              <div className="experience__spine">
                <div className={`experience__dot${idx === 0 ? ' experience__dot--active' : ''}`} />
                {idx < education.length - 1 && <div className="experience__line" />}
              </div>
              <div className="experience__card">
                <div className="experience__card-header">
                  <div>
                    <h3 className="experience__role">{ed.degree}</h3>
                    <p className="experience__company">
                      <i className="ri-building-line"></i> {ed.institution}
                    </p>
                  </div>
                  <span className="experience__period">
                    <i className="ri-calendar-line"></i> {ed.period}
                  </span>
                </div>
                <p className="experience__edu-detail">{ed.detail}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default Experience;
